import { getAuthErrorCode } from './auth-error-handler';
import { ACCOUNT_DELETION_PENDING_CODE } from './auth-error-types';

/**
 * Sign-in errors the form shows inline only, with no toast on top: the
 * calm account-deletion message would otherwise appear twice.
 */
export function isInlineOnlyAuthError(error: unknown): boolean {
  return getAuthErrorCode(error) === ACCOUNT_DELETION_PENDING_CODE;
}
